module.exports = __webpack_public_path__ + "static/img/iphone1.c7b9ba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/iphone1.png
// module id = niMn
// module chunks = 1